<template>
  <div class="container adjusted-container-width" id="thankyou-wrapper">
    <div class="suceedIconWrapper">
      <img src="@/assets/images/components/checked_icon.svg" />
    </div>
    <Message :type="type" />
    <div class="recWrapper">
      <RecommandedItems
        :recommandations="this.recList"
        :type="type"
        isThankYou="true"
      />
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import RecommandedItems from "@/components/RecommandedItems";
import Message from "@/views/plus/thankYou/shardComponents/Message";

export default {
  name: "ThankYou",
  components: { RecommandedItems, Message },
  props: ["recList", "type"],
  methods: {
    ...mapMutations(["setLoaderDisplay"])
  }
};
</script>

<style lang="scss" scoped>
#thankyou-wrapper.container {
  margin-top: 40px;
  @media only screen and (min-width: 1200px), screen and (max-width: 576px) {
    padding-right: 0;
    padding-left: 0;
  }
  .suceedIconWrapper {
    display: none;
  }

  .recWrapper {
    margin-bottom: calc(
      54px - 1rem
    ); /*54px at the design. minus 1 rem from the recommended component*/
  }
  @media only screen and (max-width: 768px) {
    margin-top: 32px;
    .suceedIconWrapper {
      text-align: center;
      margin-bottom: 32px;
      display: block;
    }
  }
}
</style>
